export default __webpack_public_path__ + "static/media/logoMb.ccd0eae1.png";